var SWATCH_DEBUG = true; // set to false to disable logging

function log() {
  if (!SWATCH_DEBUG) return;
  console.log('[CardSwatch]', ...arguments);
}

function initSwatch(card) {
  // Skip if already initialized
  if (card.dataset.swatchInit) return;
  card.dataset.swatchInit = 'true';

  const swatches = card.querySelectorAll('[data-card-swatches] .card-swatch');
  if (!swatches.length) return;

  let variants;
  try {
    variants = JSON.parse(card.getAttribute('data-variants').replace(/&quot;/g, '"'));
  } catch(e) { return; }

  const colorIndex = parseInt(card.getAttribute('data-color-index'), 10);

  const priceWrapper  = card.querySelector('[data-card-price-wrapper]');
  const badgeWrapper  = card.querySelector('[data-card-badge]');
  const addButton     = card.querySelector('[data-card-add-button]');
  const addButtonText = card.querySelector('[data-card-add-button-text]');
  const variantInput  = card.querySelector('[data-card-variant-input]');
  const primaryImage  = card.querySelector('[data-card-primary-image]');
  const overlayBtn = card.querySelector('.hf-best__atc-btn');

  function updateCard(variant) {
    if (!variant) return;

    // Price
    if (priceWrapper) {
      const priceContainers = priceWrapper.querySelectorAll('.price');
      const priceRegular    = priceWrapper.querySelector('.price__regular .price-item--regular');
      const priceSaleEl     = priceWrapper.querySelector('.price__sale .price-item--sale');
      const priceCompare    = priceWrapper.querySelector('.price__sale .price-item--regular');
      const fallback        = priceWrapper.querySelector('.price-item--regular') || priceWrapper.querySelector('.price-item');

      if (variant.on_sale && variant.compare_at_price) {
        priceContainers.forEach(function(p) { p.classList.add('price--on-sale'); });
        if (priceSaleEl)  priceSaleEl.textContent  = variant.price;
        if (priceCompare) priceCompare.textContent = variant.compare_at_price;
      } else {
        priceContainers.forEach(function(p) { p.classList.remove('price--on-sale'); });
        var target = priceRegular || fallback;
        if (target) target.textContent = variant.price;
      }
    }

    // Badges
    if (badgeWrapper) {
      var soldOutClass = badgeWrapper.getAttribute('data-sold-out-class') || '';
      var saleClass    = badgeWrapper.getAttribute('data-sale-class') || '';
      badgeWrapper.innerHTML = '';
      var span = document.createElement('span');
      span.className = 'badge badge--bottom-left';
      if (!variant.available) {
        span.classList.add(soldOutClass);
        span.textContent = 'Sold out';
        badgeWrapper.appendChild(span);
      } else if (variant.on_sale) {
        span.classList.add(saleClass);
        span.textContent = 'Sale';
        badgeWrapper.appendChild(span);
      }
    }

    // Add-to-cart button
    if (addButton) {
      addButton.disabled = !variant.available;
      if (addButtonText) {
        addButtonText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }

    // Variant hidden input
    if (variantInput) {
      variantInput.value    = variant.id;
      variantInput.disabled = !variant.available;
    }

    // Image swap
    if (primaryImage && variant.featured_image) {
      primaryImage.classList.add('swatch-fade');
      setTimeout(function() {
        primaryImage.srcset = '';
        primaryImage.src = variant.featured_image;
        primaryImage.classList.remove('swatch-fade');
      }, 150);
    }

    if (overlayBtn) {
      if (!variant.available) {
        overlayBtn.style.display = 'none';
      } else {
        overlayBtn.style.display = '';
        overlayBtn.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          fetch('/cart/add', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variant.id, quantity: 1 })
          }).then(function(r) {
            if (r.ok) {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              window.location.reload();
            }
          });
        };
      }
    }
  }

  log('Initialized card', card, '| variants:', variants.length, '| colorIndex:', colorIndex);

  swatches.forEach(function(swatch) {
    swatch.addEventListener('click', function() {
      swatches.forEach(function(s) { s.classList.remove('active'); });
      swatch.classList.add('active');

      var swatchValue = swatch.getAttribute('data-swatch-value');
      log('--- Swatch clicked:', swatchValue);

      var matching = variants.filter(function(v) {
        return v['option' + (colorIndex + 1)] === swatchValue;
      });
      log('Matching variants:', matching);

      var variant = matching.find(function(v) { return v.available; }) || matching[0];
      log('Selected variant:', variant);

      if (variant) {
        log('on_sale:', variant.on_sale, '| available:', variant.available, '| compare_at_price:', variant.compare_at_price);
        log('badgeWrapper found:', !!badgeWrapper);
        if (badgeWrapper) {
          log('data-sold-out-class:', badgeWrapper.getAttribute('data-sold-out-class'));
          log('data-sale-class:', badgeWrapper.getAttribute('data-sale-class'));
        }
        updateCard(variant);
        log('Badge innerHTML after update:', badgeWrapper ? badgeWrapper.innerHTML : 'N/A');
      } else {
        log('ERROR: no variant found for swatch value', swatchValue);
      }
    });
  });

  // Init overlay button to match the first active swatch on page load
  var firstActiveSwatch = card.querySelector('[data-card-swatches] .card-swatch');
  if (firstActiveSwatch) {
    var initValue = firstActiveSwatch.getAttribute('data-swatch-value');
    var initMatching = variants.filter(function(v) {
      return v['option' + (colorIndex + 1)] === initValue;
    });
    var initVariant = initMatching.find(function(v) { return v.available; }) || initMatching[0];
    if (initVariant) updateCard(initVariant);
  }
}

function initAllSwatches() {
  document.querySelectorAll('[data-product-card]').forEach(initSwatch);
}

// Run on initial page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllSwatches);
} else {
  initAllSwatches();
}

// Re-run when Shopify injects new cards (infinite scroll, filtering, etc.)
const swatchObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    mutation.addedNodes.forEach(function(node) {
      if (node.nodeType !== 1) return;
      // The added node itself might be a card
      if (node.hasAttribute('data-product-card')) {
        initSwatch(node);
      }
      // Or it might contain cards (e.g. a grid wrapper was injected)
      node.querySelectorAll('[data-product-card]').forEach(initSwatch);
    });
  });
});

swatchObserver.observe(document.body, { childList: true, subtree: true });